import { ApiMethodCallback, ApiMethodResultStatus } from '../ApiMethod';
import { createErrorResult } from '../ApiMethodResponseCreator';
import { getAccessTokenOnBehalfOfAddin, saveSsoApiCallback, SsoErrorCode } from 'owa-addins-sso';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getWebApplicationResourceForAddin,
    isAnyDialogOpen,
    showSsoDialog,
    SsoDialogType,
} from 'owa-addins-store';

const OSF_ERROR_KEY = 'Error';
const ACCESS_TOKEN_KEY = 'accessToken';

export interface GetAccessTokenApiMethodData {
    forceConsent?: boolean;
    // auth Challenge contains claims used for doing MFA sign in
    authChallenge?: string;
}

export default function getAccessTokenApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: GetAccessTokenApiMethodData,
    callback: ApiMethodCallback
) {
    if (!isFeatureEnabled('addin-getAccessTokenAsync-api')) {
        callback(createErrorResult(SsoErrorCode.OperationNotSupported));
        return;
    }

    if (!isAddinSSOEnabled(controlId)) {
        callback(createErrorResult(SsoErrorCode.NotSsoAgave));
        return;
    }

    if (isAnyDialogOpen()) {
        callback(createErrorResult(SsoErrorCode.InternalError));
        return;
    }

    const ssoCallback = (error: SsoErrorCode, token?: string): void => {
        if (error) {
            callback(createOsfErrorResult(error));
        } else {
            callback(createOsfSuccessResult(token));
        }
    };

    saveSsoApiCallback(ssoCallback);

    if (data.forceConsent) {
        showSsoDialog(controlId, SsoDialogType.OmexConsent, data.authChallenge);
    } else if (data.authChallenge) {
        showSsoDialog(controlId, SsoDialogType.MFASignIn, data.authChallenge);
    } else {
        getAccessTokenOnBehalfOfAddin(controlId, data.authChallenge);
    }
}

function isAddinSSOEnabled(controlId: string): boolean {
    return !!getWebApplicationResourceForAddin(controlId);
}

function createOsfErrorResult(error: SsoErrorCode): any {
    return {
        [OSF_ERROR_KEY]: error,
    };
}

function createOsfSuccessResult(data: string): any {
    return {
        [OSF_ERROR_KEY]: ApiMethodResultStatus.Success,
        [ACCESS_TOKEN_KEY]: data,
    };
}
